// extracted by mini-css-extract-plugin
export default {"GridItem":"periodo_GridItem__noAal"};